<template>
  <div>
    <PageHead title="公文发文"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">公文编号：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入公文编号"
                v-model="queryForm.documentNumber"
              />
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">公文名称：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入公文名称"
                v-model="queryForm.companyName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">拟稿单位：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.organizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择拟稿单位"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
          </div>
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">拟稿人：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入拟稿人"
                v-model="queryForm.drafterName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待提交</a-select-option>
                <a-select-option :value="1">正在审批</a-select-option>
                <a-select-option :value="2">已归档</a-select-option>
                <a-select-option :value="3">退回</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading"
            >查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="canCel()"
            >取消</a-button
          >
        </div>
      </div>
      <div class="mt20 mb20">
        <a-button type="primary" @click="goDetial()" icon="plus">拟稿</a-button>
        <span class="searching">
          检索统计:
          <span>{{ data.count }}条</span>
        </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data.data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 10
        }}</span>
        <div slot="serialNumber" class="statusDiv" slot-scope="text, record">
          <div v-if="record.serialNumberType == '1'">
            <div v-if="text">{{ text }}</div>
            <div v-else>未填编号</div>
          </div>
          <div v-if="record.serialNumberType == '2'">
            <div v-if="text">{{ text }}</div>
            <div v-else>非编号文</div>
          </div>
        </div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0">待提交</span>
          <span v-if="text == 1">正在审批</span>
          <span v-if="text == 2">已归档</span>
          <span v-if="text == 3">退回</span>
          <span v-if="text == 4">取消</span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id, 1)"
            >查看</a-button
          >
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)"
              >修改</a-button
            >
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
              >删除</a-button
            > </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>

          <a-divider type="vertical" />
          <a-button type="link" class="btn-link" @click="history(record.id)">
            历史记录
          </a-button>
        </div>
        <div slot="serialNumberType" class="statusDiv" slot-scope="text">
          <div v-if="text == 1">编号文</div>
          <div v-if="text == 2">非编号文</div>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="data.count"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      v-model="ishistory"
      title="历史修改记录"
      :footer="null"
      :width="800"
    >
      <a-table
        :pagination="false"
        :columns="historyColumns"
        :data-source="historyList"
        :row-key="(record) => record.fromVersion"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goHistoryDetial(record.id, record.version)"
          >
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="historyPage"
          :default-current="historyPage"
          :total="historyTotal"
          :pageSize="historySize"
          @change="historyPageChange"
        />
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },
  {
    title: '公文编号',
    dataIndex: 'serialNumber',
    key: 'serialNumber',
    scopedSlots: { customRender: 'serialNumber' },
    ellipsis: true
  },
  {
    title: '公文名称',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true
  },
  {
    title: '拟稿人',
    dataIndex: 'drafterName',
    key: 'drafterName',
    ellipsis: true
  },
  {
    title: '拟稿单位',
    dataIndex: 'companyName',
    key: 'companyName',
    ellipsis: true
  },
  {
    title: '公文类型',
    dataIndex: 'serialNumberType',
    key: 'serialNumberType',
    scopedSlots: { customRender: 'serialNumberType' },
    ellipsis: true
  },

  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },
  {
    title: '更新时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 260
  }
]
const historyColumns = [
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },

  {
    title: '修改人',
    dataIndex: 'modifyUserName',
    key: 'modifyUserName',
    ellipsis: true
  },

  {
    title: '表单版本',
    dataIndex: 'fromVersion',
    key: 'fromVersion'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]
import {
  officialDocumentList,
  officialDocumentDelete,
  getHistoryList
} from './api/api'
import { mapState, mapActions } from 'vuex'
import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      expand: false,
      queryForm: {},
      data: {},
      columns,
      loading: false,
      page: 1,
      size: 10,
      historyColumns,
      ishistory: false,
      historyList: [], //历史版本列表
      historyPage: 1,
      historyTotal: 0,
      historySize: 5,
      historyId: '' // 被查看历史版本的人id
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  created() {
    //获取组织机构
    this.getorganizeListFn()
    this.officialDocumentGainList()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'official-document')
      })
      recallProcessPromise
        .then((value) => {
          this.officialDocumentGainList()
        })
        .catch((error) => {
          this.officialDocumentGainList()
        })
    },
    ...mapActions(['getorganizeListFn']),
    history(id) {
      //查看历史记录
      this.historyId = id
      this.historyLoad()
      this.ishistory = true
    },
    historyLoad() {
      // 获取历史版本列表
      let params = {
        id: this.historyId,
        page: this.historyPage,
        size: this.historySize
      }
      getHistoryList(params).then((res) => {
        if (res.data.code == 0) {
          this.historyList = res.data.data
          this.historyTotal = res.data.count
        }
      })
    },
    // 历史记录分页
    historyPageChange(pageNumber) {
      this.historyPage = pageNumber
      this.historyLoad()
    },
    goHistoryDetial(id, version) {
      const { href } = this.$router.resolve({
        path: '/OfficialDocumentDetial',
        query: {
          id,
          version,
          isEdit: '1'
        }
      })
      window.open(href, '_self')
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.loading = true

          officialDocumentDelete({ id }).then((res) => {
            if (res.data.code == 0) {
              this.loading = false
              this.page = 1
              this.officialDocumentGainList()
              this.$message.success('删除成功')
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        }
      })
    },
    goDetial(id, type) {
      if (type) {
        const { href } = this.$router.resolve({
          path: '/OfficialDocumentDetial',
          query: {
            id: id,
            isEdit: '1'
          }
        })
        window.open(href, '_self')
      } else {
        if (id) {
          const { href } = this.$router.resolve({
            path: '/OfficialDocumentDetial',
            query: {
              id: id
            }
          })
          window.open(href, '_self')
        } else {
          const { href } = this.$router.resolve({
            path: '/OfficialDocumentDetial'
          })
          window.open(href, '_self')
        }
      }
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.officialDocumentGainList()
    },

    subMit() {
      this.officialDocumentGainList()
    },
    officialDocumentGainList() {
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      this.loading = true
      officialDocumentList(params).then((res) => {
        if (res.data.code == 0) {
          this.loading = false
          this.data = res.data
        }
      })
    },
    canCel() {
      this.queryForm = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: no-wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.mt20 {
  display: flex;
  justify-content: space-between;
  .searching {
    font-size: 14px;
    margin-right: 50px;
    color: #000;
    span {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/OfficialDocument/index.vue